<template>
  <v-row
    v-if="workorder"
    class="py-0"
    :style="
      workorder.tipo == 'intestazione'
        ? { backgroundColor: '#3f51b5' }
        : workorder.colore_riga
        ? workorder.colore_riga
        : workorder.macchina_impegnata == 1
        ? { backgroundColor: '#EE9922' }
        : { backgroundColor: riga.colore_riga }
    "
  >
    <WorkorderLayoutColumn
      @button_click="handleButtonClick"
      :colonna="colonna"
      :gestione_team_enabled="gestione_team_enabled"
      :key="i"
      v-for="(colonna, i) in riga.colonne
        ? riga.colonne.filter((c) => c.validita == 1)
        : []"
      :workorder="workorder"
      :hasIntestazione="hasIntestazione"
    />
  </v-row>
</template>
<script>
import ProduzioneRowObject from "@/classes/ProduzioneRowObject.js";

export default {
  name: "WorkorderLayoutRow",
  components: {
    WorkorderLayoutColumn: () =>
      import("@/components/WorkorderLayout/WorkorderLayoutColumn.vue"),
  },
  props: {
    gestione_team_enabled: { type: Number, default: 0 },
    riga: { type: Object, default: new ProduzioneRowObject() },
    workorder: { type: Object, default: () => {} },
    hasIntestazione: { type: Number, default: 0 },
  },
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    handleButtonClick(text, item, codice_btn, query) {
      console.log("button click", text, item, codice_btn.query);
      this.$emit("button_click", text, item, codice_btn, query);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>